var map = {
	"./agree.svg": "YXWr",
	"./android_icon.svg": "8Upu",
	"./box_icon.svg": "78p8",
	"./call.svg": "c1si",
	"./camera.svg": "FX1Y",
	"./camera_close.svg": "fuod",
	"./camera_icon.svg": "ZVKB",
	"./cancel_call.svg": "pPs6",
	"./change_position.svg": "RQwv",
	"./close.svg": "Qsut",
	"./copy.svg": "QGZx",
	"./csd.svg": "UovQ",
	"./dropdown.svg": "ghdw",
	"./enlarge.svg": "1Pce",
	"./exit_full_screen.svg": "GXQR",
	"./full_screen.svg": "Aksr",
	"./group.svg": "mdMi",
	"./group/add.svg": "svl6",
	"./group/collapse.svg": "Ngkp",
	"./group/expand.svg": "CHps",
	"./group/invite.svg": "lesg",
	"./group/setting.svg": "Fihk",
	"./group/tips.svg": "j062",
	"./hands.svg": "cMZy",
	"./hangup.svg": "z0gQ",
	"./hide.svg": "WAwp",
	"./id.svg": "7xhD",
	"./interCut/drag.svg": "t6EJ",
	"./interCut/intercut_audio.svg": "tP9w",
	"./interCut/list.svg": "DpuL",
	"./interCut/list_loop.svg": "z1Mc",
	"./interCut/name_tips.svg": "adK8",
	"./interCut/next.svg": "oLPJ",
	"./interCut/one_loop.svg": "gp2Y",
	"./interCut/one_play.svg": "0Pib",
	"./interCut/pause_play.svg": "Isgc",
	"./interCut/prev.svg": "+b09",
	"./interCut/share_icon.svg": "rigW",
	"./interCut/start_play.svg": "2PRk",
	"./interCut/stop_share.svg": "9o2+",
	"./invite_copy_icon.svg": "SLHk",
	"./invite_icon.svg": "uUwP",
	"./invite_part_icon.svg": "GdyQ",
	"./ios_icon.svg": "AU/4",
	"./istop.svg": "RGId",
	"./lang.svg": "qmbw",
	"./layout_icon.svg": "MzIt",
	"./live.svg": "JOTO",
	"./live_icon.svg": "sg59",
	"./live_refresh.svg": "kkxo",
	"./lock.svg": "C2Lp",
	"./meet_chat.svg": "gzp8",
	"./mic.svg": "Gc9X",
	"./mic_close.svg": "rCfQ",
	"./more.svg": "36Ua",
	"./part_camera.svg": "I/Vf",
	"./part_camera_close.svg": "EyvL",
	"./part_mic.svg": "IRBa",
	"./part_mic_close.svg": "2ZFA",
	"./participant.svg": "g6D8",
	"./phone_meet_icon.svg": "1zEc",
	"./qrcode.svg": "Rquv",
	"./record_icon.svg": "UWqa",
	"./recording.svg": "5+5L",
	"./refresh.svg": "cIB4",
	"./reject.svg": "c7U0",
	"./resolution_tips.svg": "ff0d",
	"./search.svg": "1Exu",
	"./share.svg": "vcbS",
	"./share_screen.svg": "s0DK",
	"./single.svg": "XAAv",
	"./sip.svg": "Gbo+",
	"./touch.svg": "pwDr",
	"./user.svg": "ad/c",
	"./videomeet_icon.svg": "c/nG",
	"./warning.svg": "i36l",
	"./web_icon.svg": "wsl3",
	"./windows_icon.svg": "cjS4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SK6o";